import React from "react";
import { Button, Col, Modal, ListGroup, ProgressBar } from "react-bootstrap";
const Case2 = ({ handleClose, Handleform2 }) => {
  return (
    <>
      <Col className='shadow' md={8}>
        <ProgressBar
          className=' Fpro shadow'
          variant='info'
          animated
          now={25}
        />
        <Modal.Header closeButton>
          <Button
            onClick={handleClose}
            size='sm'
            className='btn-light Psbutton shadow'
          >
            <i className='fa fa-arrow-left' aria-hidden='true'></i>
          </Button>
        </Modal.Header>

        <Modal.Title className='text-center'>
          Select Prescription Type
        </Modal.Title>
        <Modal.Body>
          <ListGroup variant='flush'>
            <ListGroup.Item>
              <Button
                size='sm'
                onClick={() => {
                  Handleform2("Single-Vision");
                }}
                className='Psbutton shadow btn-light'
              >
                Single-Vision/Powered Eyeglasses
              </Button>
              <p className='my-2  FP'>
                Corrects for one field of vision (near, intermediate, or
                distance)
              </p>
            </ListGroup.Item>
            <ListGroup.Item>
              <Button
                size='sm'
                onClick={() => {
                  Handleform2("Progressive");
                }}
                value='Progressive'
                className='Psbutton shadow btn-light'
              >
                Bifocal/Progressive Eyeglasses
              </Button>
              <p className='my-2 FP'>Distance & Near vision in same lenses.</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h6 className='my-2 FP'>
                Please choose the lens/Prescription depending upon need and your
                eye
              </h6>
            </ListGroup.Item>
          </ListGroup>
        </Modal.Body>
      </Col>
    </>
  );
};

export default Case2;
